import React from 'react';

const About = () => {
  return (
    <div className="about">
      <h2>About This App</h2>
      <p>
        This is a small app to search among{' '}
        <a href="https://github.com">Github</a> users, select one, and view
        their availability and their first 5 public repos. Built with{' '}
        <a href="https://reactjs.org">React</a> using hooks, on top of the{' '}
        <a href="https://developer.github.com/v3/">Github API</a>.
      </p>
      <sub>Version: 1.1.0</sub>
    </div>
  );
};

export default About;
